import { MoreThirdPartyDetailsForm } from "./Form";
import { useMoreThirdPartyDetails } from "./hooks/useMoreThirdPartyDetails";

export const MoreThirdPartyDetails = () => {
  const props = useMoreThirdPartyDetails();
  return <MoreThirdPartyDetailsForm {...props} />;
};

export default MoreThirdPartyDetails;
